export const sortCoveragesByName = (arr, order, propertyPath) => {
  const orderMap = {};
  order.forEach((coverage, index) => {
    orderMap[coverage] = index;
  });

  arr.sort((a, b) => {
    const valueA = getPropertyByPath(a, propertyPath);
    const valueB = getPropertyByPath(b, propertyPath);

    const orderA = orderMap[valueA];
    const orderB = orderMap[valueB];

    if (orderA !== undefined && orderB !== undefined) {
      return orderA - orderB;
    }

    if (orderA === undefined && orderB !== undefined) {
      return 1;
    }

    if (orderA !== undefined && orderB === undefined) {
      return -1;
    }

    return 0;
  });

  return arr;
};

function getPropertyByPath(obj, path) {
  const parts = path.split('.');
  let current = obj;

  for (const part of parts) {
    if (current && current.hasOwnProperty(part)) {
      current = current[part];
    } else {
      return undefined;
    }
  }

  return current;
}

export const allPoliciesLabels = (products: any[]) => {
  let labels;
  products.forEach((product) => {
    const allPolicies = product?.policyCoverageDetails?.allPolicies;
    labels = allPolicies
      ? allPolicies.map((policy) => ({
          label: policy?.title ?? '-',
          children: policy?.coverages?.map(
            (coverage) => coverage.coverageTitle,
          ),
        }))
      : [{ label: 'Gegevens worden niet verstrekt' }];
  });
  if (!products[0]?.policyCoverageDetails?.allPolicies) {
    return [{ label: 'Bezig met laden...' }];
  } else {
    return labels;
  }
};

export const updateTheme = (originalTheme, partnerTheme) => {
  const updatedTheme = JSON.parse(JSON.stringify(originalTheme)); // Deep clone the original theme

  function recursiveUpdate(target, source) {
    for (const key in source) {
      if (source.hasOwnProperty(key)) {
        if (
          typeof source[key] === 'object' &&
          source[key] !== null &&
          !Array.isArray(source[key])
        ) {
          if (!target.hasOwnProperty(key) || typeof target[key] !== 'object') {
            target[key] = {};
          }
          recursiveUpdate(target[key], source[key]);
        } else {
          target[key] = source[key];
        }
      }
    }
  }

  recursiveUpdate(updatedTheme, partnerTheme);
  return updatedTheme;
};

export const handlePartnerContext = (props, defaultTheme) => {
  const isPartner = props.hasOwnProperty('partnerContext');
  const partnerContext = isPartner ? props.partnerContext : null;

  const theme = partnerContext
    ? updateTheme(defaultTheme, partnerContext?.partnerTheme || {})
    : defaultTheme;

  return {
    isPartner,
    partnerContext,
    theme,
  };
};

export const getApiCredentials = (isPartner, partnerContext) => {
  if (
    isPartner &&
    partnerContext?.connectionDetails?.clientId &&
    partnerContext?.connectionDetails?.clientSecret
  ) {
    return {
      token: '',
      clientId: partnerContext?.connectionDetails?.clientId,
      clientSecret: partnerContext?.connectionDetails?.clientSecret,
    };
  }

  return {
    token: '',
    clientId: process.env.KIZI_PUBLIC_API_ACCESS_TOKEN_CLIENT_ID ?? '',
    clientSecret: process.env.KIZI_PUBLIC_API_ACCESS_TOKEN_CLIENT_SECRET ?? '',
  };
};
